"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControlContext = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../utils/helpers");

var _uniqid = _interopRequireDefault(require("uniqid"));

var _FormStyled = require("./Form-styled");

var _Form = require("./Form");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormControlContext = (0, _react.createContext)({
  horizontal: undefined,
  error: undefined,
  success: undefined,
  _generatedId: undefined
});
exports.FormControlContext = FormControlContext;
FormControlContext.displayName = 'FormControlContext';

var FormControl = function FormControl(_ref) {
  var children = _ref.children,
      error = _ref.error,
      success = _ref.success,
      horizontal = _ref.horizontal,
      other = _objectWithoutProperties(_ref, ["children", "error", "success", "horizontal"]);

  var _generatedId = (0, _react.useMemo)(_uniqid.default, []);

  var formControlContext = (0, _helpers.useContextState)({
    horizontal: horizontal,
    error: error,
    success: success,
    _generatedId: _generatedId
  });
  var formContext = (0, _react.useContext)(_Form.FormContext);
  return _react.default.createElement(FormControlContext.Provider, {
    value: formControlContext
  }, _react.default.createElement(_FormStyled.StyledFormControl, _extends({
    error: error,
    success: success,
    horizontal: horizontal,
    noValidation: formContext.noValidation
  }, other), children));
};

exports.default = FormControl;
FormControl.propTypes = {
  /** The content of the component. */
  children: _propTypes.default.node,

  /** The FormControl should show an error. */
  error: _propTypes.default.bool,

  /** The FormControl should show success. */
  success: _propTypes.default.bool,

  /** The FormControl should layout as horizontal elements. */
  horizontal: _propTypes.default.bool,

  /** If the FormControl doesn't need validation, you can set this to true to tighten up the bottom margin. */
  noValidation: _propTypes.default.bool
};
FormControl.defaultProps = {};
FormControl.displayName = 'FormControl';